import { render } from "./AccountDeleteModal.vue?vue&type=template&id=7cda2424"
import script from "./AccountDeleteModal.vue?vue&type=script&lang=js"
export * from "./AccountDeleteModal.vue?vue&type=script&lang=js"
script.render = render

export default script